<script>
  import { onMount } from "svelte";

  // Getting The Current Date & Time And Setting It
  let currentDateTime = new Date();

  onMount(() => {
    const interval = setInterval(() => {
      currentDateTime = new Date();
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  });

  const formatter = new Intl.DateTimeFormat("default", {
    year: "numeric",
  });

  $: date = formatter.format(currentDateTime);
</script>

<svelte:head>
  <title>Časopis Gskul - školský časopis Gymnázia v Giraltovciach</title>
  <meta
    name="description"
    content="Školský časopis Gymnázia v Giraltovciach - Gskul"
  />
  <html lang="sk" />
</svelte:head>

<main>
  <header>
    <img src="../logo.svg" width="480" alt="Gskul logo" />
  </header>

  <nav class="menu">
    <a href="#home" class="active">Domov</a>
    <a href="#team">Tím</a>
    <a href="#archive">Archív</a>
    <a href="#contact">Kontakt</a>
  </nav>

  <div class="photo" />

  <div class="team" id="team">
    <h1>Kto za tým stojí?</h1>
    <div class="members">
      <div class="member">
        <img src="../liliana.png" alt="member" />
        <p class="name">Liliana Čurlíková</p>
        <span class="role">Šéfredaktorka</span>
      </div>
      <div class="member">
        <img src="../david.png" alt="member" />
        <p class="name">Dávid Šoltýs</p>
        <span class="role">Grafik</span>
      </div>
      <div class="member">
        <img src="../valovska.jpg" alt="member" />
        <p class="name">PhDr. Blanka Vaľovská</p>
        <span class="role">Jazyková úprava</span>
      </div>
      <div class="member">
        <img src="../johnny.png" alt="member" />
        <p class="name">Ján Ďuraš</p>
        <span class="role">Technický dozor <br /> a pôvodný vzhľad</span>
      </div>
    </div>

    <p class="editors">
      <strong style="color: #cc0044;">+</strong> množstvo šikovných redaktorov, či
      iných prispievateľov.
    </p>
    <a class="signup" href="#contact">Pridaj sa k nim aj ty!</a>
  </div>

  <div class="archive" id="archive">
    <h1>Archív</h1>

    <div class="magazines">
      <div class="magazine">
        <a
          href="https://drive.google.com/file/d/1IdtVovAET3XmRc5Nty4UqFYAfkFGhkxf/view?usp=sharing"
          target="_blank"
        >
          <img
            src="../archiv/GSKUL-2024_25-c2.jpg"
            alt="Gskul - Šk. rok 2024/25 č. 2"
          />
        </a>
      </div>

      <div class="magazine">
        <a
          href="https://drive.google.com/file/d/1vBR0EIb3Q-IhoBeyhVWA25C4IWGdeJ92/view?usp=sharing"
          target="_blank"
        >
          <img
            src="../archiv/GSKUL-2024_25-c1.jpg"
            alt="Gskul - Šk. rok 2024/25 č. 1"
          />
        </a>
      </div>

      <div class="magazine">
        <a href="../archiv/2024-jun.pdf" target="_blank">
          <img src="../archiv/2024-jun.jpg" alt="Gskul Jún 2024" />
        </a>
      </div>

      <div class="magazine">
        <a href="../archiv/2024-januar.pdf" target="_blank">
          <img src="../archiv/2024-januar.jpg" alt="Gskul Január 2024" />
        </a>
      </div>

      <div class="magazine">
        <a href="../archiv/2023-jun.pdf" target="_blank">
          <img src="../archiv/2023-jun.jpg" alt="Gskul Jún 2023" />
        </a>
      </div>

      <div class="magazine">
        <a href="../archiv/2023-januar.pdf" target="_blank">
          <img src="../archiv/2023-januar.jpg" alt="Gskul Január 2023" />
        </a>
      </div>

      <div class="magazine">
        <a href="../archiv/2022-jun.pdf" target="_blank">
          <img src="../archiv/2022-jun.jpg" alt="Gskul Jún 2022" />
        </a>
      </div>

      <div class="magazine">
        <a href="../archiv/2022-januar.pdf" target="_blank">
          <img src="../archiv/2022-januar.jpg" alt="Gskul Január 2022" />
        </a>
      </div>

      <div class="magazine">
        <a href="../archiv/2020-jar.pdf" target="_blank">
          <img src="../archiv/2020-jar.jpg" alt="Gskul Jar 2020" />
        </a>
      </div>

      <div class="magazine">
        <a href="../archiv/2019-zima.pdf" target="_blank">
          <img src="../archiv/2019-zima.jpg" alt="Gskul Zima 2019" />
        </a>
      </div>

      <div class="magazine">
        <a href="../archiv/2019-leto.pdf" target="_blank">
          <img src="../archiv/2019-leto.jpg" alt="Gskul Leto 2019" />
        </a>
      </div>

      <div class="magazine">
        <a href="../archiv/2018-zima.pdf" target="_blank">
          <img src="../archiv/2018-zima.jpg" alt="Gskul Zima 2018" />
        </a>
      </div>

      <div class="magazine">
        <a href="../archiv/2018-leto.pdf" target="_blank">
          <img src="../archiv/2018-leto.jpg" alt="Gskul Leto 2018" />
        </a>
      </div>
    </div>
  </div>

  <div class="contact" id="contact">
    <h1>Kontakt</h1>

    <p style="font-size: 1.4em;">
      Máš otázky, návrhy, pripomienky, alebo chceš do časopisu <img
        style="padding: 0 0.4rem;"
        src="../logo.svg"
        width="92"
        alt="Gskul logo"
      /> prispieť aj ty?
    </p>

    <a class="email" href="mailto:redakcia@gskul.com">redakcia@gskul.com</a>
  </div>

  <footer>
    <p>
      Copyright © {date}
      <a href="http://spojenaskolagiraltovce.sk/"
        >Spojená škola, Dukelská 26/30, Giraltovce</a
      > - Všetky práva vyhradené
    </p>
  </footer>
</main>

<style lang="scss">
  @import url("https://fonts.googleapis.com/css?family=Oswald:500");

  :global(html) {
    scroll-behavior: smooth;
  }

  :global(body) {
    background-color: #0a0c0f;
    font-family: "Varela Round", sans-serif;
    padding: 0;
    margin: 0;
    font-size: 1.2em;
  }

  main {
    text-align: center;
    padding: 8rem 0;
    margin: 0 auto;
  }

  header {
    display: flex;
    justify-content: center;
  }

  .menu {
    width: 100%;
    text-align: center;
    padding: 4rem 0;
  }

  .menu a {
    font-family: "Oswald", sans-serif;
    font-weight: 500;
    text-transform: uppercase;
    text-decoration: none;
    color: #525f7a;
    margin: 0 2rem;
    font-size: 1.3em;
    letter-spacing: 1px;
    position: relative;
    display: inline-block;
  }

  .menu a:hover {
    color: #cc0044;
  }

  .menu .active {
    color: #cc0044;
  }

  .menu a:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 3px;
    background: #cc0044;
    top: 47%;
    animation: out 0.2s cubic-bezier(1, 0, 0.58, 0.97) 1 both;
  }

  .menu a:hover:before {
    animation: in 0.2s cubic-bezier(1, 0, 0.58, 0.97) 1 both;
  }

  @keyframes in {
    0% {
      width: 0;
      left: 0;
      right: auto;
    }

    100% {
      left: 0;
      right: auto;
      width: 100%;
    }
  }

  @keyframes out {
    0% {
      width: 100%;
      left: auto;
      right: 0;
    }

    100% {
      width: 0;
      left: auto;
      right: 0;
    }
  }

  @keyframes show {
    0% {
      opacity: 0;
      transform: translateY(-10px);
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .photo {
    padding: 21rem 0;
    background: url("../casopis.jpg");
    background-size: cover;
    background-position: 0 0rem;
    background-repeat: no-repeat;
    background-attachment: fixed;
  }

  h1 {
    font-family: "Oswald", sans-serif;
    color: #cc0044;
    font-size: 5em;
    text-transform: uppercase;
    letter-spacing: 5px;
  }

  .team {
    color: #525f7a;
    padding: 6rem 8rem;
  }

  .members {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  .member {
    padding: 2.8rem 1.4rem;
  }

  .member img {
    border-radius: 100%;
    width: 180px;
  }

  .name {
    font-family: "Oswald", sans-serif;
    color: #cc0044;
    font-size: 1.6em;
    text-transform: uppercase;
    letter-spacing: 5px;
    margin-bottom: 0.2rem;
    margin-top: 1.2rem;
    width: 18rem;
  }

  .role {
    font-family: "Oswald", sans-serif;
    color: #c2c9d6;
    font-size: 1.2em;
    text-transform: uppercase;
    letter-spacing: 5px;
  }

  .editors {
    color: #c2c9d6;
    font-size: 1.6em;
    margin: 2.8rem 0;
  }

  .signup {
    font-family: "Oswald", sans-serif;
    font-weight: 500;
    text-transform: uppercase;
    text-decoration: none;
    color: #c2c9d6;
    font-size: 2.6em;
    letter-spacing: 2px;

    transition: all 0.2s ease-out;
  }

  .signup:hover {
    color: #cc0044;
    font-size: 3.2em;
    letter-spacing: 6px;
  }

  .archive {
    color: #525f7a;
    padding: 4rem 8rem;
    background: url("../archiv.jpg");
    background-size: cover;
    background-position: 0 0rem;
    background-repeat: no-repeat;
    background-attachment: fixed;
  }

  .magazines {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  .magazine {
    padding: 0.7rem;
  }

  .magazine img {
    height: 32rem;
  }

  .contact {
    padding: 4rem 0;
    color: #525f7a;
    padding: 4rem 8rem;
  }

  .email {
    font-size: 4.6em;
    color: #cc0044;

    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-word;
    hyphens: auto;
  }

  footer {
    color: #525f7a;
  }

  footer a {
    color: #cc0044;
  }

  @media (max-width: 1056px) {
    .email {
      font-size: 3.6em;
    }
  }

  @media (max-width: 786px) {
    .email {
      font-size: 2em;
    }

    h1 {
      font-size: 4em;
    }

    .team,
    .archive,
    .contact {
      padding: 4rem 2rem;
    }

    header,
    footer {
      padding: 0 2rem;
    }
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }

  @media (max-width: 456px) {
    h1 {
      font-size: 3em;
    }

    .magazine img {
      height: 24rem;
    }
  }
</style>
